







































import { Component, Prop, Vue } from "vue-property-decorator";

export interface NavigationObject {
  label: string;
  link: string;
  classes: string[];
}

@Component
export default class Navigation extends Vue {
  @Prop({
    type: Array,
    required: true
  })
  public items!: NavigationObject[];

  public mounted() {
    $("body").scrollspy({
      target: "nav",
      offset: 56
    });
  }

  public onClick() {
    $(".navbar-collapse").collapse("hide");
  }

  public computeClassesFor(item: NavigationObject) {
    return ["nav-link"].concat(item.classes);
  }

  public showToast() {
    window.location.href= "https://www.glastrinkhalm.shop/"
  }
}
